import React from 'react';
import { number } from 'prop-types';
import { LogoDashboardLink } from '../../Links';
import { bigQueryClickEvent, mixpanelInteractionEvent } from '../utils';
import { LINKS } from '../constants';

const SellerLogoDashboardLink = ({ sellerId }) => (
    <LogoDashboardLink
        bigQueryData={bigQueryClickEvent(sellerId, LINKS.SELLING_LOGOS)}
        mpData={mixpanelInteractionEvent(LINKS.SELLING_LOGOS)}
    />
);

SellerLogoDashboardLink.propTypes = {
    sellerId: number.isRequired,
};

export default SellerLogoDashboardLink;
